import { useLayoutEffect, useState } from 'react';

interface ActiveTabSize {
  width: number;
  left: number;
  height: number;
  initial: boolean;
}

export function useActiveTab(activeTabId: string): ActiveTabSize {
  const [activeTab, setActiveTab] = useState<ActiveTabSize>({
    width: 0,
    left: 0,
    height: 0,
    initial: true,
  });

  useLayoutEffect(() => {
    const tab = document.querySelector<HTMLDivElement>(
      `[data-tab-id="${activeTabId}"]`,
    );

    if (!tab) {
      return;
    }

    setActiveTab(prev => ({
      width: tab.offsetWidth,
      left: tab.offsetLeft,
      height: tab.offsetHeight,
      initial: prev.width === 0,
    }));
  }, [activeTabId]);

  return activeTab;
}
